/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type ProfileDeleteCodeSubmitInput = {
  securityCode: string
}

export type VerifyCodeInput = {
  code: string
}

export type RequestProfileDeleteCodeMutationVariables = Exact<{
  [key: string]: never
}>

export type RequestProfileDeleteCodeMutation = {
  __typename: "Mutation"
  requestProfileDeleteCode?: {
    __typename: "DeleteResponse"
    success: boolean
  } | null
}

export type VerifyProfileDeleteCodeMutationVariables = Exact<{
  input: Types.VerifyCodeInput
}>

export type VerifyProfileDeleteCodeMutation = {
  __typename: "Mutation"
  verifyProfileDeleteCode: {
    __typename: "VerifyCodeInputResponse"
    valid: boolean
    attemptsLeft: number
  }
}

export type SubmitProfileDeleteCodeMutationVariables = Exact<{
  input: Types.ProfileDeleteCodeSubmitInput
}>

export type SubmitProfileDeleteCodeMutation = {
  __typename: "Mutation"
  submitProfileDeleteCode: { __typename: "DeleteResponse"; success: boolean }
}

export const RequestProfileDeleteCodeDocument = gql`
  mutation RequestProfileDeleteCode {
    requestProfileDeleteCode(input: {})
      @rest(
        method: "POST"
        endpoint: "userSpace"
        path: "/profile/security-code/send"
      ) {
      success
    }
  }
`
export type RequestProfileDeleteCodeMutationFn = Apollo.MutationFunction<
  RequestProfileDeleteCodeMutation,
  RequestProfileDeleteCodeMutationVariables
>

/**
 * __useRequestProfileDeleteCodeMutation__
 *
 * To run a mutation, you first call `useRequestProfileDeleteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProfileDeleteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProfileDeleteCodeMutation, { data, loading, error }] = useRequestProfileDeleteCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestProfileDeleteCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestProfileDeleteCodeMutation,
    RequestProfileDeleteCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestProfileDeleteCodeMutation,
    RequestProfileDeleteCodeMutationVariables
  >(RequestProfileDeleteCodeDocument, options)
}
export type RequestProfileDeleteCodeMutationHookResult = ReturnType<
  typeof useRequestProfileDeleteCodeMutation
>
export type RequestProfileDeleteCodeMutationResult =
  Apollo.MutationResult<RequestProfileDeleteCodeMutation>
export type RequestProfileDeleteCodeMutationOptions =
  Apollo.BaseMutationOptions<
    RequestProfileDeleteCodeMutation,
    RequestProfileDeleteCodeMutationVariables
  >
export const VerifyProfileDeleteCodeDocument = gql`
  mutation VerifyProfileDeleteCode($input: VerifyCodeInput!) {
    verifyProfileDeleteCode: verifyProfileDeleteCode(input: $input)
      @rest(
        method: "POST"
        path: "/profile/security-code/verify"
        endpoint: "userSpace"
      ) {
      valid
      attemptsLeft
    }
  }
`
export type VerifyProfileDeleteCodeMutationFn = Apollo.MutationFunction<
  VerifyProfileDeleteCodeMutation,
  VerifyProfileDeleteCodeMutationVariables
>

/**
 * __useVerifyProfileDeleteCodeMutation__
 *
 * To run a mutation, you first call `useVerifyProfileDeleteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyProfileDeleteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyProfileDeleteCodeMutation, { data, loading, error }] = useVerifyProfileDeleteCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyProfileDeleteCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyProfileDeleteCodeMutation,
    VerifyProfileDeleteCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VerifyProfileDeleteCodeMutation,
    VerifyProfileDeleteCodeMutationVariables
  >(VerifyProfileDeleteCodeDocument, options)
}
export type VerifyProfileDeleteCodeMutationHookResult = ReturnType<
  typeof useVerifyProfileDeleteCodeMutation
>
export type VerifyProfileDeleteCodeMutationResult =
  Apollo.MutationResult<VerifyProfileDeleteCodeMutation>
export type VerifyProfileDeleteCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyProfileDeleteCodeMutation,
  VerifyProfileDeleteCodeMutationVariables
>
export const SubmitProfileDeleteCodeDocument = gql`
  mutation submitProfileDeleteCode($input: ProfileDeleteCodeSubmitInput!) {
    submitProfileDeleteCode: submitProfileDeleteCode(input: $input)
      @rest(
        method: "POST"
        endpoint: "userSpace"
        path: "/profile/delete-proposal"
        bodySerializer: "deleteUserProfile"
      ) {
      success
    }
  }
`
export type SubmitProfileDeleteCodeMutationFn = Apollo.MutationFunction<
  SubmitProfileDeleteCodeMutation,
  SubmitProfileDeleteCodeMutationVariables
>

/**
 * __useSubmitProfileDeleteCodeMutation__
 *
 * To run a mutation, you first call `useSubmitProfileDeleteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProfileDeleteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProfileDeleteCodeMutation, { data, loading, error }] = useSubmitProfileDeleteCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitProfileDeleteCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitProfileDeleteCodeMutation,
    SubmitProfileDeleteCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubmitProfileDeleteCodeMutation,
    SubmitProfileDeleteCodeMutationVariables
  >(SubmitProfileDeleteCodeDocument, options)
}
export type SubmitProfileDeleteCodeMutationHookResult = ReturnType<
  typeof useSubmitProfileDeleteCodeMutation
>
export type SubmitProfileDeleteCodeMutationResult =
  Apollo.MutationResult<SubmitProfileDeleteCodeMutation>
export type SubmitProfileDeleteCodeMutationOptions = Apollo.BaseMutationOptions<
  SubmitProfileDeleteCodeMutation,
  SubmitProfileDeleteCodeMutationVariables
>
